<template>
  <div class="footer bg-main-color">
    <div class="mx-auto w-full">
      <div class="">
        <div>
          <ul class="footer-links text-xs flex-col sm:flex-row">
            <li
              v-if="can_show_menu"
              v-for="section in footerBarSections"
              :key="section.id"
              class="p-1 md:p-3 mx-0 lg:p-1"
            >
              <a
                href=""
                :class="footer_btn_class"
                @click="on_section_click($event, section.id)"
                v-html="section.name"
              ></a>
            </li>

            <li
              v-if="can_show_menu"
              v-for="(link, index) in footer_additional_links"
              :key="'footer_link_' + index"
              class="p-1 md:p-3 mx-0 lg:p-1"
            >
              <a
                :href="link.href"
                :class="footer_btn_class"
                @click="on_footer_content_click($event, index)"
                target="_blank"
                v-html="link.title"
              ></a>
            </li>

            <li class="p-1 md:p-3 mx-0 lg:p-1">
              <a
                href="#"
                class="rounded inline-block py-3 px-2 md:px-6 rounded text-white shadow-md bg-footer-btn-color hover:bg-footer-btn-color-hover hover:shadow-lg"
                @click.prevent="on_footer_content_click($event, 'aboutus')"
                target="_blank"
                >About Us</a
              >
            </li>
            <li class="p-1 md:p-3 mx-0 lg:p-1">
              <a
                href="#"
                class="rounded inline-block py-3 px-2 md:px-6 rounded text-green-800 shadow-md bg-gray-300 hover:bg-blue-100 hover:shadow-lg"
                @click.prevent="on_footer_isi_click()"
                target="_blank"
                v-if="show_isi"
                >Important Safety Information</a
              >
              <span v-else>&nbsp;</span>
            </li>
            <li class="p-1 md:p-3 mx-0 lg:p-1">
              <a
                href="#"
                class="rounded inline-block py-3 px-2 md:px-6 rounded text-white shadow-md bg-footer-btn-color hover:bg-footer-btn-color-hover hover:shadow-lg"
                @click.prevent="on_footer_content_click($event, 'contact')"
                target="_blank"
                >How Can We Help? Contact Us</a
              >
            </li>
          </ul>
          <div
            class="text-blue-300 flex flex-col sm:flex-row text-xs pt-2 pb-1 px-10"
          >
            <span
              class="mx-auto px-1 text-center sm:text-left block sm:inline-block sm:ml-0 py-1 sm:py-0"
            >
              ProtoExpo &copy; August 2020
            </span>
            <a
              href="#"
              class="px-1 py-1 sm:py-0 hover:text-white"
              target="_blank"
              v-ga="$ga.commands.trackExternalLink.bind(this, 'http://')"
              >Privacy Policy</a
            >
            <a
              href="#"
              class="px-1 py-1 sm:py-0 hover:text-white"
              target="_blank"
              v-ga="$ga.commands.trackExternalLink.bind(this, 'https://')"
              >Terms of Use</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "Footer",
  computed: {
    ...mapState([
      "app_state",
      "page_state",
      "current_section",
      "footer_additional_links",
      "sections",
      "sections_content",
      "site_config"
    ]),
    ...mapGetters(["footerBarSections", "sectionContent", "eventTag"]),

    can_show_menu() {
      return (
        (this.$store.state.app_state == 0 &&
          this.$store.state.page_state != 2) ||
        this.$store.state.app_state != 0
      );
    },
    footer_btn_class() {
      let str = "rounded inline-block py-3 px-2 md:px-6 rounded text-white ";
      if (this.site_config.use_footer_as_links) {
        str += "underline hover:text-gray-300";
      } else {
        str +=
          "shadow-md bg-footer-btn-color hover:bg-footer-btn-color-hover hover:shadow-lg";
      }
      return str;
    },
    show_isi() {
      if (this.current_section < 0 || this.current_section == "") return false;

      return (
        "undefined" !=
        typeof this.sections_content.isi.subids[this.current_section]
      );
    }
  },
  methods: {
    getCurrentISIContent(section_id) {
      return this.sectionContent("isi").subids[section_id];
    },
    on_section_click(e, section_id) {
      e.preventDefault();
      for (let i = 0; i < this.sections.length; i++) {
        let section = this.sections[i];
        if (section.id == section_id) {
          this.$store.dispatch("set_current_section", section.id);
          this.$store.dispatch("set_popup_state", section.popup_type);
          try {
            this.$ga.event(this.eventTag + "menubar", "click", section.name, 1);
          } catch (err) {}
          break;
        }
      }
    },
    on_footer_content_click(e, section) {
      this.$store.dispatch("set_secondary_section", {
        section: "footer",
        sub_section: section
      });

      this.$store.dispatch(
        "set_popup_state",
        this.sections_content["footer"].subids[section].type
      );
    },
    on_footer_link_click(e, link_index) {
      try {
        this.$ga.event(
          this.eventTag + "footerlink",
          "click",
          this.footer_additional_links[i].title,
          1
        );
      } catch (err) {}
    },
    on_footer_isi_click() {
      this.$store.dispatch("set_secondary_section", {
        section: "isi",
        sub_section: this.current_section
      });
      this.$store.dispatch(
        "set_popup_state",
        this.getCurrentISIContent(this.current_section).type
      );
    }
  }
};
</script>
<style>
.footer {
  margin-top: auto;
  padding: 12px 0;
}
.footer img {
  height: auto;
  align-self: bottom;
  display: inline-block;
  flex: 0;
  padding: 0 7px;
}
.footer .logo-container {
  align-items: center;
  flex-wrap: wrap;
}
.logo-container .logo-1 img {
  min-width: 126px;
  width: 126px;
}
.logo-container .logo-2 img {
  min-width: 125px;
  width: 125px;
}
.logo-container .logo-3 img {
  min-width: 150px;
  width: 150px;
}
.footer-links {
  height: 100%;
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: space-around;
  text-transform: uppercase;
}
.footer-links li {
  margin: 0;
}

img.company-secondary-logo {
  max-width: 121px;
}

@media only screen and (min-width: 610px) {
  body .footer .logo-container {
    flex-wrap: nowrap;
  }
  .logo-container .logo-1 img {
    min-width: 160px;
  }
  .logo-container .logo-2 img {
    min-width: 158px;
  }
  .logo-container .logo-3 img {
    min-width: 190px;
  }
}
@media only screen and (min-width: 1024px) {
  body .footer .logo-container {
    flex-wrap: nowrap;
  }
  .footer img {
    padding: 0 5px;
  }

  .logo-container .logo-1 img {
    min-width: 122px;
  }
  .logo-container .logo-2 img {
    min-width: 120px;
  }
  .logo-container .logo-3 img {
    min-width: 145px;
  }

  img.company-secondary-logo {
    max-width: 118px !important;
  }
}
@media only screen and (min-width: 1197px) {
  body .footer .logo-container {
    flex-wrap: nowrap;
  }
  .footer img {
    padding: 0 5px;
  }
  .logo-container .logo-1 img {
    min-width: 151px;
  }
  .logo-container .logo-2 img {
    min-width: 149px;
  }
  .logo-container .logo-3 img {
    min-width: 180px;
  }
  img.company-secondary-logo {
    max-width: 146px !important;
  }
}
@media only screen and (min-width: 1400px) {
  .footer img {
    padding: 0 20px;
  }
  .logo-container .logo-1 img {
    min-width: 176px;
  }
  .logo-container .logo-2 img {
    min-width: 175px;
  }
  .logo-container .logo-3 img {
    min-width: 210px;
  }
  img.company-secondary-logo {
    max-width: 170px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue